import { addDays } from "../../../../../../react-core/utils/date";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { ModelPortfolioTabType } from "../../../../../../Wrap/Constants/Enums/Domain/ModelPortfolioTabType";
import { OrderDirection } from "../../../../../../Wrap/Constants/Enums/Domain/OrderDirection";
import { OrderType } from "../../../../../../Wrap/Constants/Enums/Domain/OrderType";
import { ProductType } from "../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { GBPInvestmentCode, ProcessType } from "../../../../../Shared/IST/Resource/Content";

export const transformNewItem = (
    investments,
    orderType: OrderType,
    orderDirection: OrderDirection,
    totalValue: number,
    popValue?: boolean,
    isTargetAllocation?: boolean
) => {
    return investments.map((ele) => {
        const value = ele.Investment.Allocation * totalValue * 0.01;

        return {
            Instrument: ele.Investment,
            Type: orderType,
            OrderValue: popValue ? Number(value.toFixed(2)) : null,
            OrderQuantity: null,
            OrderPercentage: popValue ? ele.Investment.Allocation : null,
            InstrumentCode: ele.Investment.InstrumentCode,
            needToggle: ele.needToggle,
            modelPortfolioType: ele.needToggle ? ModelPortfolioTabType.HubModel : null,
            isSellAll: false,
            isLimit: false,
            ExpiryDate: JsonDateParser.toDate(addDays(new Date(), 90)),
            BuyOrSell: orderDirection,
            isTargetAllocation: isTargetAllocation,
            tradeable: true,
        };
    });
};

export const initCashProduct = (data) => {
    return {
        Allocation: null,
        AssetClass: data.AssetClass,
        DisplayName: data.Name,
        ProductId: data.ProductId,
        UnitPrice: { Amount: 1, Currency: CurrencyCode.GBP },
        Name: data.Name,
        InstrumentCode:null
    }
}

export const initInstrumentList = (
    data, 
    orderType: OrderType,
    orderDirection: OrderDirection,
    isTargetAllocation?: boolean) => {
    return {
        Instrument: initCashProduct(data),
        Type: orderType,
        OrderValue: null,
        OrderQuantity: null,
        // OrderPercentage: popValue ? ele.Investment.Allocation : null,
        // InstrumentCode: ele.Investment.InstrumentCode,
        // needToggle: ele.needToggle,
        // modelPortfolioType: ele.needToggle ? ModelPortfolioTabType.HubModel : null,
        isSellAll: false,
        isLimit: false,
        ExpiryDate: JsonDateParser.toDate(addDays(new Date(), 90)),
        BuyOrSell: orderDirection,
        isTargetAllocation: isTargetAllocation,
        tradeable: true,
    };
};

export const clearAllocation = (data, orderType: OrderType, processType?: ProcessType) => {
    const _data: any[] = data.concat();
    const _orderValue = processType == ProcessType.SwitchFrom ? 0 : null
    return _data.map((ele) => {
        return {
            ...ele,
            isSellAll: false,
            OrderValue: _orderValue,
            OrderQuantity: null,
            OrderPercentage: null,
            Type: orderType,
        };
    });
};
